import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ReplaySubject, Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ShClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { ActionItem } from '../action-item/entities/action-item.entity';
import { ShCompactNavigationItemComponent } from '../compact-navigation-item/compact-navigation-item/compact-navigation-item.component';
import { ShCompactNavigationMainActionComponent } from '../compact-navigation-item/compact-navigation-main-action/compact-navigation-main-action.component';
import { ShIconModule } from '../icon/icon.module';
import { NavigationItem, OpenableNavigationItem } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-compact-navigation',
    templateUrl: './compact-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterModule,
        CommonModule,
        ShIconModule,
        ShCompactNavigationItemComponent,
        ShCompactNavigationMainActionComponent,
        ShClickOutsideDirective
    ]
})
export class ShCompactNavigationComponent {
    primaryNavItems$: Subject<OpenableNavigationItem[]> = new ReplaySubject(1);
    secondaryNavItems$: Subject<OpenableNavigationItem[]> = new ReplaySubject(1);

    @Input() mainActionItem!: ActionItem;
    @Input() set primaryNavItems(primaryNavItems: NavigationItem[]) {
        this.primaryNavItems$.next(primaryNavItems);
    }

    @Input() set secondaryNavItems(secondaryNavItems: NavigationItem[]) {
        this.secondaryNavItems$.next(secondaryNavItems);
    }

    @Input() applicationName: string;
    @Input() applicationEnvironment: string;
    @Input() applicationVersion: string;
    @Input() showApplicationInformation: boolean = false;

    selectionChanged(selected: boolean, selectedIndex: number, navItems: NavigationItem[], primary: boolean) {
        if (selected) {
            this.handleSelected(selectedIndex, navItems, primary);
        } else {
            this.handleDeselected(selectedIndex, navItems, primary);
        }
    }

    noneSelected(navItems: OpenableNavigationItem[], primary: boolean) {
        if (navItems) {
            this.updateNavItems(primary, navItems, (navItem, index) => false);
        }
    }

    private handleSelected(selectedIndex: number, navItems: NavigationItem[], primary: boolean): void {
        this.updateNavItems(primary, navItems, (navItem, index) => index === selectedIndex);
    }

    private handleDeselected(selectedIndex: number, navItems: OpenableNavigationItem[], primary: boolean): void {
        this.updateNavItems(primary, navItems, (navItem, index) => (selectedIndex === index ? false : navItem.isOpen));
    }

    private updateNavItems(
        primary: boolean,
        navItems: OpenableNavigationItem[],
        openCondition: (navItem: OpenableNavigationItem, index: number) => boolean | undefined
    ) {
        const updatedNavItems = navItems.map((navItem, index) => {
            const newItem: OpenableNavigationItem = {
                ...navItem,
                isOpen: openCondition(navItem, index)
            };
            return newItem;
        });

        if (primary) {
            this.primaryNavItems$.next(updatedNavItems);
        } else {
            this.secondaryNavItems$.next(updatedNavItems);
        }
    }
}
